import { render } from "./OrderSupplierDetail.vue?vue&type=template&id=900c3bc6"
import script from "./OrderSupplierDetail.vue?vue&type=script&lang=js"
export * from "./OrderSupplierDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__